<script>
import {defineComponent} from 'vue'
import {Swiper, SwiperSlide} from 'swiper/vue'
import 'swiper/css'

import {usePage, router, Link} from '@inertiajs/vue3'
import {computed, onMounted, ref} from 'vue'
import axios from 'axios'
import {useCatalogStore} from '@js/store/CatalogStore.js'
import IconX from "@js/components/Icons/IconX.vue";

export default defineComponent({
    name: "CatalogCategoryNav",
    components: {
        IconX,
        Swiper,
        SwiperSlide,
        Link,
    },
    data() {
        return {
            items: [],
        }
    },
    methods: {
        getData() {
            axios.post('/axios/catalog/get-sub-categories', {
                category_slug: this.currentCategory,
            }).then(response => {
                this.items = response.data
            })
        },
        norm(s) {
            return String(s ?? '')
                .toLocaleLowerCase('ru-RU')
                .replace(/\s+/g, ' ')
                .trim()
        },
        isSelectedInFilters(item, field = 'sub_category') {
            const title = typeof item === 'string' ? item : item?.title
            const needle = this.norm(title)

            return this.catalogStore.selected_filters?.some(f => {
                if (field && f.field !== field) return false

                const candidates = []
                if (f.title != null) candidates.push(f.title)
                if (Array.isArray(f.value)) candidates.push(...f.value)
                else if (f.value != null) candidates.push(f.value)

                return candidates.map(this.norm).includes(needle)
            }) ?? false
        },
        toggle(title) {
            const t = String(title ?? '').trim()
            if (!t) return

            const list = Array.isArray(this.catalogStore.selected_sub_categories)
                ? [...this.catalogStore.selected_sub_categories]
                : []

            // сравнение без регистра/лишних пробелов
            const n = this.norm(t)
            const idx = list.findIndex(v => this.norm(v) === n)

            if (idx === -1) list.push(t)
            else list.splice(idx, 1)

            this.catalogStore.selected_sub_categories = list

            // применить фильтры
            this.catalogStore.pagination && (this.catalogStore.pagination.current_page = 1)
            this.catalogStore.applyFiltersDebounced?.()
        },
    },
    computed: {
        currentCategory: function () {
            const page = usePage()
            const path = new URL(page.props.ziggy.location).pathname
            const parts = path.split('/')
            return parts.includes('catalog') ? parts[parts.indexOf('catalog') + 1] : null
        },
    },
    mounted() {
        this.getData()
    },
    setup() {
        const catalogStore = useCatalogStore()

        return {catalogStore}
    }
})
</script>

<template>
    <div v-if="items.length" class="w-full overflow-hidden max-md:-mt-2 pt-2 md:pt-5 select-none">
        <Swiper :slides-per-view="'auto'" :space-between="16" class="!overflow-visible cursor-grab">
            <template v-for="(item, index) in items" :key="index">
                <SwiperSlide class="!w-auto">
                    <button @click.prevent="toggle(item.title)"
                            :class="[isSelectedInFilters(item) ? 'border-baseColor' : 'border-gray-300 md:hover:border-baseColor']"
                            class="group relative inline-flex items-center px-5 py-2.5 border md:hover:bg-baseColor max-md:active:border-baseColor rounded-lg whitespace-nowrap text-sm font-medium transition">
                        {{ item.title }}
                        <span v-if="isSelectedInFilters(item)"
                              class="absolute -top-1 -right-1 border border-baseColor md:group-hover:border-black bg-baseColor rounded-full p-0.5 transition">
                            <IconX class="w-3 h-3 stroke-black"/>
                        </span>
                    </button>
                </SwiperSlide>
            </template>
        </Swiper>
    </div>
</template>

<style scoped lang="scss">

</style>
